module.exports = __webpack_public_path__ + "media/images/img_consul2-7a93f83594025af3703ae60c868464ad.png";